import React from 'react';
import CreateCase_Comp from '../../Components/CreateCase/CreateCase';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function CreateCase() {
  return (
    <>
    <Dashboard_Comp>
    <CreateCase_Comp />
    </Dashboard_Comp>
    </>
  )
}

export default CreateCase;